"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCardValidation = void 0;
const credit_card_constants_1 = require("../constants/credit-card.constants");
const error_types_contants_1 = require("../constants/error-types.contants");
class CreditCardValidation {
    static getFirstNameOrLastNameError(value) {
        if (this.isValueEmpty(value)) {
            return error_types_contants_1.ErrorTypes.IS_REQUIRED;
        }
        if (this.isValidLength(value, credit_card_constants_1.MIN_LENGTH_FOR_FIRST_NAME_AND_LAST_NAME)) {
            return error_types_contants_1.ErrorTypes.INVALID_VALUE;
        }
        return error_types_contants_1.ErrorTypes.EMPTY;
    }
    static isValidFirstNameOrLastNameValue(value) {
        return this.getFirstNameOrLastNameError(value) === error_types_contants_1.ErrorTypes.EMPTY;
    }
    static isValueEmpty(value) {
        return !!value ? value.trim().length === 0 : true;
    }
    static isValidLength(value, length) {
        return !!value ? value.trim().length < length : false;
    }
    static removeExpecialCharacters(value) {
        if (value) {
            return value.replace(/[^a-zA-Z ]+/g, '').toUpperCase();
        }
        return '';
    }
    static removeCharacteres(value) {
        if (value) {
            return value.replace(/[^0-9]+/g, '');
        }
        return '';
    }
    static restrictNumeric(key) {
        return !!/[\d\s]/.test(key);
    }
    static restrictExpiry(key, target) {
        const digit = key;
        if (!/^\d+$/.test(digit) || this.hasTextSelected(target)) {
            return false;
        }
        const value = `${target.value}${digit}`.replace(/\D/g, '');
        return value.length > 4;
    }
    static hasTextSelected(target) {
        return target.selectionStart !== null && target.selectionStart !== target.selectionEnd;
    }
    static formatExpiry(e, target) {
        let digit = e.key;
        const value = target.value;
        if (e.code && e.code.indexOf('Numpad') > -1) {
            digit = e.key;
        }
        if (!/^\d+$/.test(digit)) {
            return;
        }
        const val = `${value}${digit}`;
        if (/^\d$/.test(val) && val !== '0' && val !== '1') {
            e.preventDefault();
            target.value = `0${val}${credit_card_constants_1.EXPIRATION_DATE_SEPARATOR}`;
        }
        else if (/^\d\d\d?$/.test(val)) {
            e.preventDefault();
            const m1 = parseInt(val[0], 10);
            const m2 = parseInt(val[1], 10);
            if (m2 > 2 && m1 !== 0) {
                target.value = `0${m1}${credit_card_constants_1.EXPIRATION_DATE_SEPARATOR}${m2}`;
            }
            else {
                if (val.length === 2) {
                    target.value = `${val}${credit_card_constants_1.EXPIRATION_DATE_SEPARATOR}`;
                }
                else {
                    target.value = `${value}${credit_card_constants_1.EXPIRATION_DATE_SEPARATOR}${digit}`;
                }
            }
        }
    }
    static getExpiryDateMessage(value = '') {
        const [month, year] = value.trim().split(credit_card_constants_1.EXPIRATION_DATE_SEPARATOR);
        if (!month || !year) {
            return error_types_contants_1.ErrorTypes.IS_REQUIRED;
        }
        const currentYear = new Date().getFullYear();
        const fullYear = Number(`${credit_card_constants_1.FIRST_TWO_DIGITS_OF_THE_CURRENT_CENTURY}${year}`);
        const currentMonth = new Date().getMonth() + 1;
        if (Number(month) > credit_card_constants_1.MAX_MONTH_FOR_EXPIRATION_DATE || Number(month) < credit_card_constants_1.MIN_MONTH_FOR_EXPIRATION_DATE) {
            return error_types_contants_1.ErrorTypes.INVALID_EXPIRATION_DATE;
        }
        if (Number(month) < Number(currentMonth) && currentYear === fullYear) {
            return error_types_contants_1.ErrorTypes.INVALID_EXPIRATION_DATE;
        }
        if (fullYear > credit_card_constants_1.MAX_YEAR_FOR_EXPIRATION_DATE || fullYear < currentYear) {
            return error_types_contants_1.ErrorTypes.INVALID_EXPIRATION_DATE;
        }
        return error_types_contants_1.ErrorTypes.EMPTY;
    }
    static isValidExpiryDate(value = '') {
        return this.getExpiryDateMessage(value) === error_types_contants_1.ErrorTypes.EMPTY;
    }
    static getDocumentMessage(value = '') {
        if (this.isValueEmpty(value)) {
            return error_types_contants_1.ErrorTypes.IS_REQUIRED;
        }
        return error_types_contants_1.ErrorTypes.EMPTY;
    }
    static isValidDocumentValue(value) {
        return this.getDocumentMessage(value) === error_types_contants_1.ErrorTypes.EMPTY;
    }
}
exports.CreditCardValidation = CreditCardValidation;
